import { pdfjs } from 'react-pdf';
import React, { useState, useEffect, useRef } from 'react';
import {
    Box,
    Skeleton, 
  } from '@mui/material';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// LazyPDFPage コンポーネント（PDF の各ページを Canvas 経由で画像化し、IntersectionObserver で lazy load する）
const LazyPDFPage = ({ pdf, pageNumber, scale = 1 }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    let observer;
    if (containerRef.current) {
      observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !imageUrl) {
            // 指定ページを取得して Canvas にレンダリング
            pdf.getPage(pageNumber).then((page) => {
              const viewport = page.getViewport({ scale });
              const canvas = document.createElement('canvas');
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              const context = canvas.getContext('2d');
              page.render({
                canvasContext: context,
                viewport,
              }).promise.then(() => {
                setImageUrl(canvas.toDataURL('image/png'));
              });
            });
            // ロード済み後は監視を解除
            if (observer) observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(containerRef.current);
    }
    return () => {
      if (observer) observer.disconnect();
    };
  }, [pdf, pageNumber, scale, imageUrl]);

  return (
    <Box ref={containerRef} sx={{ mt: 2 }}>
      {imageUrl ? (
        <Box
          component="img"
          src={imageUrl}
          alt={`PDF Page ${pageNumber}`}
          sx={{ width: '100%', height: 'auto' }}
        />
      ) : (
        <Skeleton variant="rectangular" animation="wave" sx={{ width: '100%', height: 600 }} />
      )}
    </Box>
  );
};

export default LazyPDFPage;